import Box from '@mui/material/Box';
import Button from 'common/components/Elements/Button/Button';
import ButtonLoading from 'common/components/Elements/ButtonLoading/ButtonLoading';
import classes from 'core/components/Elements/Command/Command.style';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { EnhancedCommand } from 'core/utilities/core.types';
import React from 'react';

export interface ComponentProps {
  command: EnhancedCommand;
  small?: boolean;
}

function CommandFetchDisabled({ command, small }: ComponentProps) {
  const {
    id, title,
  } = command;

  return (
    <Box position="relative" display="inline-block">
      <Button
        action="tertiary"
        className={classes.command}
        title={title}
        small={small}
        disabled
        e2eId={id}
        loading
      >
        <CommandLinkContent command={command} />
      </Button>
      <ButtonLoading />
    </Box>
  );
}

export default CommandFetchDisabled;
